"use client";

import { useState } from "react";
import arrowDownIcon from "@/assets/images/kbv-icon-arrow-down.svg";

export default function BoltMatchLeagues({ matches = [], render = () => null }) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="overflow-hidden bg-transparent md:bg-[var(--theme-bg)] border-0 md:border md:border-[var(--theme-border)] rounded-none md:rounded-lg">
      <div
        className="hidden md:flex bg-[var(--theme-bg-muted)] items-center cursor-pointer border-b border-[var(--theme-border)] h-[40px] px-5 gap-x-[20px]"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className="grid grid-cols-[13%_11%_22%_15%_15%_10%_1fr] items-center w-full gap-x-[20px] h-full text-[14px] text-[var(--theme-text-muted)] font-bold">
          <div className="text-center truncate uppercase">Giải đấu</div>
          <div className="text-center">Ngày</div>
          <div className="text-left">Trận đấu</div>
          <div className="text-center">Kèo chấp (HT/FT)</div>
          <div className="text-center">Kèo tài xỉu (HT/FT)</div>
          <div className="text-center">1x2 (HT/FT)</div>
          <div className="flex justify-end mr-2">
            <div
              className={`w-4 h-4 bg-[var(--theme-text-muted)] transition-transform duration-300 [mask-repeat:no-repeat] [mask-position:center] [mask-size:contain] ${isExpanded ? "rotate-180" : ""}`}
              style={{ maskImage: `url(${arrowDownIcon})`, WebkitMaskImage: `url(${arrowDownIcon})` }}
            />
          </div>
        </div>
      </div>


      <div className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${isExpanded ? "max-h-[9999px]" : "max-h-0"}`}>
        {matches.map((match, idx) => (
          <div key={match.id || idx}>
            {render(match, idx)}
          </div>
        ))}
      </div>
    </div>
  );
}
